import React, { useEffect, useState } from "react";
import BannerDisplay from "./bannerdisplay/BannerDisplay.tsx";
import ReorderBanner from "./bannerdisplay/ReorderBanner.tsx";
import BannerConfig from "@/components/admin/cmsmodule/heroBanner/bannerconfig/BannerConfig.tsx";
import {
  defaultBanner,
  mockBanners,
} from "@/components/admin/cmsmodule/heroBanner/types.tsx";
import { Banner, useGetAllBanners } from "@/services/banner.service.ts";
import BannerForm from "@/components/admin/cmsmodule/heroBanner/bannerconfig/BannerForm.tsx";

const HeroBannerTabs = () => {
  const [banners, setBanners] = useState<Banner[]>(mockBanners);
  const [isReordering, setIsReordering] = useState(false);

  const [isEditingBanner, setIsEditingBanner] = useState(false);
  const [editItemData, setEditItemData] = useState<Banner>(defaultBanner);

  const [isCreatingBanner, setIsCreatingBanner] = useState(false);

  const {
    data: resp,
    refetch,
    isLoading,
    isError,
  } = useGetAllBanners({
    page: 1,
    pageSize: 10,
  });

  const handleCancelEdit = () => {
    setIsCreatingBanner(false);
    setIsEditingBanner(false);
    setEditItemData("" as any);
    refetch().then(() => console.log("refetch - edit"));
  };

  const handleCancelReorder = () => {
    setIsReordering(false);
    refetch().then(() => console.log("refetch - reorder"));
  };

  const onRefresh = () => {
    refetch().then(() => console.log("banner - on refresh"));
  };

  useEffect(() => {
    if (resp?.data?.data) {
      setBanners(resp.data.data);
    }
  }, [resp]);

  return (
    <div className="min-h-screen p-4 text-white">
      {isLoading && <p>Loading banners...</p>}
      {isError && <p className="text-red-500">Failed to load banners</p>}
      {isReordering ? ( // reorder
        <ReorderBanner
          banners={banners}
          setBanners={setBanners}
          onCancel={handleCancelReorder}
        />
      ) : isEditingBanner && editItemData ? ( // edit
        <BannerForm itemData={editItemData} onCancel={handleCancelEdit} />
      ) : isCreatingBanner ? ( // create
        <BannerForm onCancel={handleCancelEdit} />
      ) : (
        <div>
          <BannerDisplay banners={banners} setIsReordering={setIsReordering} />
          <BannerConfig
            banners={banners}
            setEditItemData={setEditItemData}
            setIsEditingBanner={setIsEditingBanner}
            setIsCreatingBanner={setIsCreatingBanner}
            refetch={onRefresh}
          />
        </div>
      )}
    </div>
  );
};

export default HeroBannerTabs;
